<div class="flex-center pad-0-M horizontal-bar-L"
     [ngClass]="{'gap-XS': type === 'user' || type === 'star' || type === 'server' || type === 'visibility', 'gap-S': type === 'application' || type === 'flux', 'no-value': value === null || value === undefined}"
     [class]="'color-' + color">
    <span class="font-M" [ngClass]="{'fw-500': !bold, 'fw-700': bold}">{{value === null || value === undefined  ? '-' : value}}</span>
    <img [src]="src" [height]="srcHeight" [ngClass]="{'rotate-45': type === 'flux'}" alt=""/>
</div>
